var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuusandoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89407 8.85393C0.647321 16.3626 -2.09041 27.6425 1.79155 38.0806C5.19488 47.2317 12.8725 53.5481 21.7167 55.606C26.8818 56.8078 32.4446 56.5572 37.7863 54.5707C52.2748 49.1826 59.6499 33.0638 54.259 18.5684C50.8536 9.41152 43.1683 3.09293 34.317 1.03914C24.858 -1.15566 14.645 1.85901 7.89407 8.85393ZM23.6066 47.4218L32.4272 9.22326C38.6458 10.6679 44.0086 15.0949 46.3889 21.4953C50.1625 31.642 45 42.9251 34.858 46.6968C31.1075 48.0916 27.2263 48.2641 23.6167 47.4242C23.6133 47.4234 23.6099 47.4226 23.6066 47.4218Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuusandoLogo);
export default __webpack_public_path__ + "static/media/juusando_logo.d8a767a0970cb8764e3559aa6edfe39e.svg";
export { ForwardRef as ReactComponent };